import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { BUTTON_SIZE, BUTTON_TYPE, DATA_ICON_STATUS } from 'consts/enum';
import { LS } from 'consts/localStorage';
import {
	generate6DigitUUID,
	onEditResponse,
	removeElement,
	setCustomTagHTML,
	storeSkipInLS,
	writeToLs,
} from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { Button } from 'ui/button/button.module';
import { Rating } from 'ui/rating/rating.module';
import { feedbackMessage } from './feedback.model';
import { FeedbackMessageTemplate } from './feedback.template';

const { IS_DISABLED, SELECTED_INDEX } = DATA_ICON_STATUS;

export default class FeedbackMessage {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
	}

	onFeedbackSubmit(index) {
		const { message } = this.data;
		const { data: messageData } = message;
		const options = messageData?.options || [];
		const { text } = options[index];
		const { payload } = options[index];

		ENGT_CHAT.get('sendMessage')(text, {
			message: {
				postback: payload,
				type: 'postback',
				text,
			},
			skipAppendToDom: true,
		});

		if (ENGT_CHAT.get('config.edit_user_input')) {
			this.renderEditBtn();
		}
	}

	onSkip(payload) {
		if (payload && (payload !== null || payload !== 'null')) {
			ENGT_CHAT.get('sendMessage')('skip', {
				message: {
					postback: payload,
					type: 'postback',
					text: 'skip',
				},
				skipAppendToDom: true,
			});
		}
	}

	initData(props) {
		this.data = { ...feedbackMessage };
		this.setter({
			...props,
			theme: ENGT_CHAT.get('config.themeColor'),
		});
		this.data.id = props.id || props.message_id || `message-${generate6DigitUUID()}`;
	}

	initWrapper() {
		this.html = new MessageWrapper({
			...this.data,
			message: this.data?.message?.data?.message || 'Feedback',
			innerHTML: FeedbackMessageTemplate(this.data),
		});
	}

	renderEditBtn() {
		const editBtn = this.html.querySelector(`#editBtn-${this.data.id}`);
		editBtn.style.display = 'block';
	}

	initComponents() {
		const { message_id, message } = this.data || {};
		const { data: messageData } = message;
		const options = messageData?.options || [];
		const skip = messageData?.enable_skip;
		const skipPostBack = messageData?.skip_postback;
		const ref = this;

		const confirmButton = new Button({
			type: BUTTON_TYPE.PRIMARY,
			size: BUTTON_SIZE.LARGE,
			label: ENGT_CHAT.get('GENERIC_STRINGS')?.['CONFIRM'] || 'Confirm',
			id: 'confirmBtn',
			radius: 18,
			applyOnHover: true,
			dataInteractiveField: true,
			onClick() {
				if (rating.getAttribute(SELECTED_INDEX)) {
					const skip = ref.html.querySelector('#skipBtn');
					const feedbackInp = ref.html.querySelector('#engFeedbackInput');
					ref.onFeedbackSubmit.call(ref, rating.getAttribute(SELECTED_INDEX));

					setTimeout(() => {
						writeToLs(
							LS().TAB_MESSAGES,
							JSON.stringify({
								tabId: ENGT_CHAT.get('socketId'),
								action: 'update_feedback_msg',
								ratingId: `${message_id}`,
								selectedValue: rating.getAttribute(SELECTED_INDEX),
							})
						);
					}, 500);
					rating.setAttribute(IS_DISABLED, true);
					if (feedbackInp) {
						feedbackInp.disabled = true;
					}
					removeElement(confirmButton);
					skip && removeElement(skipButton);
					ref.disableInputs();
					ENGT_CHAT.get('enableAllInput')();
				}
			},
		}).render();

		const skipButton = skip
			? new Button({
					type: BUTTON_TYPE.MINI,
					size: BUTTON_SIZE.SMALL,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.['SKIP'] || 'Skip',
					id: 'skipBtn',
					style: 'margin-top: 12px;',
					applyOnHover: true,
					onClick() {
						ref.onSkip(skipPostBack);
						rating.setAttribute(IS_DISABLED, true);
						const feedbackInp = ref.html.querySelector('#engFeedbackInput');
						const starWrapper = ref.html.querySelector(`#stars-${message_id}`);
						const starsSelected = starWrapper.getAttribute('data-rating-index') || -1;
						for (let i = 0; i <= parseInt(starsSelected); i++) {
							starWrapper.children[i].setAttribute('data-rating-selected', false);
						}
						starWrapper.setAttribute('data-rating-index', 0);
						starWrapper.setAttribute('data-rating-selected', 0);
						if (feedbackInp) {
							feedbackInp.disabled = true;
						}
						setTimeout(() => {
							writeToLs(
								LS().TAB_MESSAGES,
								JSON.stringify({
									tabId: ENGT_CHAT.get('socketId'),
									action: 'update_feedback_msg',
									ratingId: `${message_id}`,
									selectedValue: 'skip',
								})
							);
						}, 500);
						storeSkipInLS();
						removeElement(confirmButton);
						removeElement(skipButton);
						ref.disableInputs();
						ENGT_CHAT.get('enableAllInput')();
					},
			  }).render()
			: '';

		const rating = new Rating({
			msgId: `stars-${message_id}`,
			options,
			isOldMessage: this.data.isOldMessage,
		}).render();

		setCustomTagHTML(this.html.querySelector('confirm-btn'), this.data.isOldMessage ? '' : confirmButton);
		setCustomTagHTML(this.html.querySelector('skip-btn'), this.data.isOldMessage ? '' : skipButton);
		setCustomTagHTML(this.html.querySelector('feedback-stars'), rating);

		if (ENGT_CHAT.get('config.edit_user_input') && !this.data.isOldMessage) {
			const editButton = new Button({
				type: BUTTON_TYPE.MINI,
				label: ENGT_CHAT.get('config.default_edit_response')
					? ENGT_CHAT.get('config.default_edit_response')
					: ENGT_CHAT.get('GENERIC_STRINGS')?.['EDIT'] || 'Edit',
				id: `editBtn-${this.data.id}`,
				style: 'display:none;',
				applyOnHover: true,
				onClick() {
					const flowKey = ref.data.flow_key;
					const nodeKey = ref.data.node_key;
					if (flowKey && nodeKey) {
						this.style.display = 'none';
						onEditResponse(flowKey, nodeKey);
						ENGT_CHAT.set('editFlowId', '');
					} else console.error('flow key and and node key are not set and hence not triggering edit flow');
				},
				radius: 18,
			}).render();

			setCustomTagHTML(this.html.querySelector('edit-btn'), editButton);
			ENGT_CHAT.set('editFlowId', `editBtn-${this.data.id}`);
		} else {
			setCustomTagHTML(this.html.querySelector('edit-btn'), '');
		}
	}

	disableInputs() {
		const { message_id } = this.data;
		const starWrapper = this.html.querySelector(`#stars-${message_id}`)?.children || [];

		for (let i = 0; i < starWrapper?.length; i++) {
			const star = starWrapper[i];
			star.disabled = true;
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
